import { X } from "lucide-react";

export const ImageLightbox = ({ src, alt, onClose }) => {
  if (!src) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-pointer"
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <button onClick={onClose} className="absolute top-4 right-4 text-white/70 hover:text-white z-50">
        <X className="w-8 h-8" />
      </button>
      <img
        src={src}
        alt={alt}
        className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};
